import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-students-achievement',
  templateUrl: './students-achievement.component.html',
  styleUrls: ['./students-achievement.component.scss']
})
export class StudentsAchievementComponent implements OnInit {

 constructor(private crudService: CrudService) { }
   baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
